// The hero recording plays only while visible, and not at all for visitors
// who prefer reduced motion (they see its first frame).

export function initVideos(): void {
  const videos = Array.from(document.querySelectorAll<HTMLVideoElement>("video[autoplay]"));
  if (!videos.length) return;

  if (matchMedia("(prefers-reduced-motion: reduce)").matches) {
    for (const v of videos) {
      v.removeAttribute("autoplay");
      v.pause();
    }
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        const video = entry.target as HTMLVideoElement;
        if (entry.isIntersecting) void video.play().catch(() => {});
        else video.pause();
      }
    },
    { threshold: 0.15 },
  );
  videos.forEach((v) => io.observe(v));
}
